module.exports = __webpack_public_path__ + "static/media/restricted-regions-logo.2e36f7c7.svg";